/* eslint-disable eqeqeq */
import React, { useState } from "react";
import {
  API,
  cddCustomerTypeOptions,
  cddOptions,
  get,
  riskProfile,
  TableClasses,
  TableWrapClasses,
  TDClasses,
  THClasses,
  TRClasses,
} from "../../../config";
import { formatName, getModuleNamingBySlug } from "../../../lib/Misc";
import BootstrapTable from "react-bootstrap-table-next";
import MainBody from "../../../components/MainBody/MainBody";
import { Button } from "../../../components/ui/button";
import {
  Calendar,
  CalendarClockIcon,
  CheckCircle2,
  Clock,
  Clock3,
  Landmark,
  LucideMessageSquareShare,
} from "lucide-react";
import Confirmation from "../../../components/Confirmation";
import { Label } from "../../../components/ui/label";
import CustomLabelText from "../../../components/CustomLabelText";
import { PhoneInput } from "../../../components/ui/phone-input";
import { Checkbox } from "../../../components/ui/checkbox";
import CustomTooltip from "../../../components/CustomTooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { ResponsiveDrawerForm } from "../../../components/ResponsiveDrawerForm";
import VerifyModal from "./VerifyModal";
import RiskChange from "./RiskChange";
import EscalatedModal from "./EscalatedModal";
import CDDVerifyModal from "../../../components/Assessment_KYC/CDDVerifyModal";
import CDDVerifyCheck from "../../../components/Assessment_KYC/CDDVerifyCheck";
import KYBReportDownload from "../../../components/Assessment_KYC/KYBReportDownload";
import CDDStatus from "../../../components/Assessment_KYC/CDDStatus";
import { useOrganization } from "../../../lib/context/OrganisationContext";
import AdverseMedia from "../../../components/Assessment_KYC/AdverseMedia";
import BiometricsStatus from "./BiometricsStatus";
import { AnimatedTooltip } from "../../../components/AnimatedTooltip";
import moment from "moment";
import KYCIncomplete from "./KYCIncomplete";
import { useUser } from "../../../lib/context/UserContext";
import { AMLCTFModuleConditonIndustry } from "../../../lib/PermissionConditions";

// * Start: Vendor Listing Page
const ExpandContactTypeCDD = ({ cddsList, fetchCDDs, user = false }) => {
  // * Start: Url Management State

  const [loading, setLoading] = useState(false);

  // * End: Url Management State

  // * Start: List Management State

  const [confirmVerify, setConfirmVerify] = useState(false);
  const [cddId, setCddId] = useState("");
  const [cddItem, setCddItem] = useState("");

  const [mobile, setMobile] = useState();
  const [consent, setConsent] = useState();
  const [showVisual, setShowVisual] = useState(false);
  const [showRisk, setShowRisk] = useState(false);

  const [confirmEscalated, setConfirmEscalated] = useState(false);
  const { organizationData } = useOrganization();
  const { userData } = useUser();

  let amlCTFEnable =
    (userData?.email === "dchoradiya@gmail.com" ||
      organizationData?.organizationData?.is_aml_ctf_subscribed) &&
    AMLCTFModuleConditonIndustry(organizationData)
      ? true
      : false;

  // * End: List Management State

  //* End: Fetch Vendor List Form The API

  const toggleConfirmVerify = (id, data) => {
    if (confirmVerify) {
      setCddId();
      setCddItem();
      setMobile();
      setConsent();
    } else {
      setCddId(id);
      setCddItem(data);
    }
    setConfirmVerify(!confirmVerify);
  };

  const toggleConfirmEscalated = (id, data) => {
    if (confirmEscalated) {
      setCddId();
      setCddItem();
    } else {
      setCddId(id);
      setCddItem(data);
    }
    setConfirmEscalated(!confirmEscalated);
  };

  const toggleVisual = (id, data) => {
    if (showVisual) {
      setCddId();
      setCddItem();
    } else {
      setCddId(id);
      setCddItem(data);
    }
    setShowVisual(!showVisual);
  };

  const toggleRisk = (id, data) => {
    if (showRisk) {
      setCddId();
      setCddItem();
    } else {
      setCddId(id);
      setCddItem(data);
    }
    setShowRisk(!showRisk);
  };

  const handleVerifyID = async () => {
    try {
      setLoading(true);
      await get(
        `${API.GET_CDD_VERFIY}/${cddId}?mobile=${mobile ? mobile : ""}`,
      );
      setLoading(false);
      fetchCDDs();
    } catch (error) {
      setLoading(false);
      fetchCDDs();
    }
  };

  /**
   * * Start: Vendor Table List Record Generation
   * @param {Number} quantity (Number of EnhancedCDDs)
   * @returns {Array} Vendor List
   **/

  const cddsGenerator = (quantity) => {
    const items = [];
    let cddListData = cddsList[0];
    let contactData = cddsList[0]?.vendor_id
      ? cddsList[0]?.vendor
      : cddsList[0]?.contact_id
        ? cddsList[0]?.contact
        : cddsList[0]?.beneficiary_id
          ? cddsList[0]?.beneficiary
          : cddsList[0]?.joint_account_id
            ? cddsList[0]?.joint_account
            : cddsList[0]?.user_id
              ? cddsList[0]?.user
              : "";

    for (let i = 0; i < quantity; i++) {
      items.push({
        key: cddListData?.id,
        id: cddListData?.id ? cddListData?.id : "",
        cdd: cddListData?.cdd
          ? cddOptions?.find((item) => item.value === cddListData?.cdd)?.label
          : "-",
        cdd_customer_type: cddListData?.cdd_customer_type
          ? cddCustomerTypeOptions?.find(
              (item) => item.value === cddListData?.cdd_customer_type,
            )?.label
          : "-",

        cdd_type: cddListData?.cdd
          ? cddOptions?.find((item) => item.value === cddListData?.cdd)?.label
          : "-",
        risk: cddListData?.risk && (
          <div className="flex items-center gap-2">
            {cddListData?.risk
              ? riskProfile?.find((item) => item.value == cddListData?.risk)
                  ?.label
              : ""}{" "}
            <CustomTooltip message={"Edit"}>
              <span>
                <FontAwesomeIcon
                  icon={faEdit}
                  size="1x"
                  onClick={() => {
                    toggleRisk(cddListData?.id, cddListData);
                  }}
                />
              </span>
            </CustomTooltip>
          </div>
        ),
        source: cddListData?.source ? (
          cddListData?.source?.includes("(SMS)") ? (
            <div className="flex items-center gap-2">
              {cddListData?.source}{" "}
              {cddListData?.verifications[i]?.sms_sent_date && (
                <AnimatedTooltip
                  title={
                    <div className="flex items-center gap-4 text-sm">
                      <span>SMS Sent Date:</span>
                      <span className="flex items-center gap-1.5">
                        <Calendar className="h-4 w-4" />
                        {moment(
                          cddListData?.verifications[i]?.sms_sent_date,
                          "DD-MM-YYYY HH:mm:ss",
                        ).format("DD MMM YYYY")}
                      </span>

                      <span className="flex items-center gap-1.5">
                        <Clock3 className="h-4 w-4" />
                        {moment(
                          cddListData?.verifications[i]?.sms_sent_date,
                          "DD-MM-YYYY HH:mm:ss",
                        ).format("hh:mm:ss A")}
                      </span>
                    </div>
                  }
                >
                  <CalendarClockIcon className="h-4 w-4 text-webPrimary" />
                </AnimatedTooltip>
              )}
            </div>
          ) : (
            cddListData?.source
          )
        ) : (
          ""
        ),

        verification_document_type: cddListData?.verifications[i]
          ?.verification_document_type?.label
          ? cddListData?.verifications[i]?.verification_document_type?.label
          : "",
        date_verified: cddListData?.verifications[i]?.date_verified
          ? cddListData?.verifications[i]?.date_verified
          : "",
        verified_by: cddListData?.verifications[i]?.verified_by
          ? formatName(
              cddListData?.verifications[i]?.verified_by?.first_name,
              cddListData?.verifications[i]?.verified_by?.last_name,
            )
          : "",

        biometrics: cddListData?.verifications[i]?.["bdv_results"]?.[
          "bdv_results"
        ] ? (
          <BiometricsStatus
            results={
              cddListData?.verifications[i]?.["bdv_results"]?.["bdv_results"]
            }
          />
        ) : (
          ""
        ),
        method: cddListData?.verifications[i]?.method_title ? (
          cddListData?.verifications[i]?.method_title?.includes("(SMS)") ? (
            <div className="flex items-center gap-2">
              {cddListData?.verifications[i]?.method_title}{" "}
              {cddListData?.verifications[i]?.sms_sent_date && (
                <AnimatedTooltip
                  title={
                    <div className="flex items-center gap-4 text-sm">
                      <span>SMS Sent Date:</span>
                      <span className="flex items-center gap-1.5">
                        <Calendar className="h-4 w-4" />
                        {moment(
                          cddListData?.verifications[i]?.sms_sent_date,
                          "DD-MM-YYYY HH:mm:ss",
                        ).format("DD MMM YYYY")}
                      </span>

                      <span className="flex items-center gap-1.5">
                        <Clock3 className="h-4 w-4" />
                        {moment(
                          cddListData?.verifications[i]?.sms_sent_date,
                          "DD-MM-YYYY HH:mm:ss",
                        ).format("hh:mm:ss A")}
                      </span>
                    </div>
                  }
                >
                  <CalendarClockIcon className="h-4 w-4 text-webPrimary" />
                </AnimatedTooltip>
              )}
            </div>
          ) : (
            cddListData?.verifications[i]?.method_title
          )
        ) : (
          ""
        ),
        bureau: cddListData?.verifications[i]?.method_title?.includes("DVS") ? (
          <CDDStatus
            cdd={cddListData?.cdd == 0 ? "simplified" : "enhanced"}
            contactType={
              cddListData?.joint_account_id
                ? "joint account"
                : cddListData?.beneficiary_id
                  ? "beneficiary"
                  : cddListData?.vendor_id
                    ? getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "vendors",
                        "vendor",
                      )
                    : cddListData?.contact_id
                      ? getModuleNamingBySlug(
                          organizationData?.organizationData,
                          "contacts",
                          "customer",
                        )
                      : ""
            }
            data={cddListData}
            id={cddListData?.id}
            type={"bureau"}
            fetchData={fetchCDDs}
          />
        ) : (
          <></>
        ),
        dvs: cddListData?.verifications[i]?.method_title?.includes("DVS") ? (
          <CDDStatus
            cdd={cddListData?.cdd == 0 ? "simplified" : "enhanced"}
            contactType={
              cddListData?.joint_account_id
                ? "joint account"
                : cddListData?.beneficiary_id
                  ? "beneficiary"
                  : cddListData?.vendor_id
                    ? getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "vendors",
                        "vendor",
                      )
                    : cddListData?.contact_id
                      ? getModuleNamingBySlug(
                          organizationData?.organizationData,
                          "contacts",
                          "customer",
                        )
                      : ""
            }
            data={cddListData}
            id={cddListData?.id}
            type={"dvs"}
            fetchData={fetchCDDs}
          />
        ) : (
          <></>
        ),
        pep: cddListData?.verifications[i]?.method_title?.includes("DVS") ? (
          <CDDStatus
            cdd={cddListData?.cdd == 0 ? "simplified" : "enhanced"}
            contactType={
              cddListData?.joint_account_id
                ? "joint account"
                : cddListData?.beneficiary_id
                  ? "beneficiary"
                  : cddListData?.vendor_id
                    ? getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "vendors",
                        "vendor",
                      )
                    : cddListData?.contact_id
                      ? getModuleNamingBySlug(
                          organizationData?.organizationData,
                          "contacts",
                          "customer",
                        )
                      : ""
            }
            data={cddListData}
            id={cddListData?.id}
            type={"pep"}
            fetchData={fetchCDDs}
          />
        ) : (
          <></>
        ),
        sanction: cddListData?.verifications[i]?.method_title?.includes(
          "DVS",
        ) ? (
          <CDDStatus
            cdd={cddListData?.cdd == 0 ? "simplified" : "enhanced"}
            contactType={
              cddListData?.joint_account_id
                ? "joint account"
                : cddListData?.beneficiary_id
                  ? "beneficiary"
                  : cddListData?.vendor_id
                    ? getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "vendors",
                        "vendor",
                      )
                    : cddListData?.contact_id
                      ? getModuleNamingBySlug(
                          organizationData?.organizationData,
                          "contacts",
                          "customer",
                        )
                      : ""
            }
            data={cddListData}
            id={cddListData?.id}
            type={"sanction"}
            fetchData={fetchCDDs}
          />
        ) : (
          <></>
        ),
        adverse_media: (
          <AdverseMedia
            adverse_media_result={
              cddListData?.summaries?.length > 0
                ? cddListData?.summaries?.[0]?.adverse_media_result
                : ""
            }
            reference_no={
              cddListData?.summaries?.length > 0
                ? cddListData?.summaries?.[0]?.request_id
                : ""
            }
          />
        ),
        action: (
          <>
            <span className="flex items-center gap-2 justify-center">
              {cddListData?.kyb_report_file ? (
                <KYBReportDownload
                  setLoading={setLoading}
                  kyb_report_file={cddListData?.kyb_report_file}
                />
              ) : (
                <></>
              )}
              {cddListData?.verifications[i]?.verified === 1 ? (
                <Button
                  size={"sm"}
                  className={
                    contactData?.type == 2
                      ? "bg-green-800 hover:bg-green-900 text-white h-6 px-2"
                      : "bg-green-500 hover:bg-green-600 text-white h-6 px-2"
                  }
                >
                  <div className="flex items-center gap-1">
                    {contactData?.type == 2 ? (
                      <Landmark size={14} />
                    ) : (
                      <CheckCircle2 size={14} />
                    )}
                    <span>Verified</span>
                  </div>
                </Button>
              ) : cddListData?.verifications[i]?.verified === 2 ||
                cddListData?.verifications[i]?.verified === 3 ? (
                <>
                  <CDDVerifyModal
                    listData={cddListData}
                    setCddItem={setCddItem}
                    setCddId={setCddId}
                    cddItem={cddItem}
                    customerType={contactData?.type}
                    setLoading={setLoading}
                    cddId={cddId}
                    pending={true}
                    sectionType={cddListData?.cdd_customer_type}
                    fecthData={fetchCDDs}
                    defaultMobile={
                      contactData?.mobile
                        ? contactData?.mobile[0] === "+"
                          ? contactData?.mobile
                          : `+${contactData?.mobile}`
                        : ""
                    }
                    defaultABN={contactData?.abn}
                    cdd={cddListData?.cdd}
                  />
                  <Button
                    size={"sm"}
                    className={
                      cddListData?.verifications[i]?.verified === 2
                        ? "bg-yellow-500 hover:bg-yellow-600 text-white h-6 px-2"
                        : "bg-red-500 hover:bg-red-600 text-white h-6 px-2"
                    }
                  >
                    <div className="flex items-center gap-1">
                      <Clock size={14} />
                      <span>
                        {cddListData?.verifications[i]?.verified === 2
                          ? "Pending"
                          : "Expired"}
                      </span>
                    </div>
                  </Button>
                  {cddListData?.verifications[i]?.verified === 2 ? (
                    <CDDVerifyCheck
                      listData={cddListData}
                      setCddId={setCddId}
                      setLoading={setLoading}
                      cddId={cddId}
                      fecthData={fetchCDDs}
                    />
                  ) : (
                    <></>
                  )}
                </>
              ) : cddListData?.verifications[i]?.method !== 1 ? (
                <>
                  {cddListData?.cdd === "1" && !user && (
                    <>
                      <CustomTooltip message={"Escalate"}>
                        <span>
                          <LucideMessageSquareShare
                            size={18}
                            onClick={() => {
                              toggleConfirmEscalated(
                                cddListData?.id,
                                cddListData,
                              );
                            }}
                          />
                        </span>
                      </CustomTooltip>

                      <span>/</span>
                    </>
                  )}
                  {cddListData?.verifications[i]?.method_title ? (
                    <CDDVerifyModal
                      loading={loading}
                      listData={cddListData}
                      setCddItem={setCddItem}
                      setCddId={setCddId}
                      cddItem={cddItem}
                      customerType={contactData?.type}
                      setLoading={setLoading}
                      cddId={cddId}
                      sectionType={cddListData?.cdd_customer_type}
                      fecthData={fetchCDDs}
                      defaultMobile={
                        contactData?.mobile
                          ? contactData?.mobile[0] === "+"
                            ? contactData?.mobile
                            : `+${contactData?.mobile}`
                          : ""
                      }
                      defaultABN={contactData?.abn}
                      cdd={cddListData?.cdd}
                    />
                  ) : (
                    <KYCIncomplete
                      contactType={
                        cddsList[0]?.joint_account_id
                          ? 4
                          : cddsList[0]?.beneficiary_id
                            ? 3
                            : cddsList[0]?.contact_id
                              ? 2
                              : cddsList[0]?.vendor_id
                                ? 1
                                : ""
                      }
                      amlCTFEnable={amlCTFEnable}
                      contact={contactData}
                      type={contactData?.type}
                      entityType={contactData?.entity_type}
                      fetchData={() => fetchCDDs()}
                    />
                  )}
                </>
              ) : (
                <>
                  {cddListData?.cdd === "1" && !user && (
                    <>
                      <CustomTooltip message={"Escalate"}>
                        <span>
                          <LucideMessageSquareShare
                            size={18}
                            onClick={() => {
                              toggleConfirmEscalated(
                                cddListData?.id,
                                cddListData,
                              );
                            }}
                          />
                        </span>
                      </CustomTooltip>
                      <span>/</span>
                    </>
                  )}
                  <CustomTooltip message={"Edit"}>
                    <span>
                      <FontAwesomeIcon
                        icon={faEdit}
                        size="1x"
                        onClick={() => {
                          toggleVisual(
                            cddListData?.id,
                            cddListData?.verifications[i],
                          );
                        }}
                      />
                    </span>
                  </CustomTooltip>
                </>
              )}
            </span>
          </>
        ),
      });
    }

    if (contactData?.type == 2) {
      items.push({
        key: cddListData?.id,
        id: cddListData?.id ? cddListData?.id : "",
        cdd: cddListData?.cdd
          ? cddOptions?.find((item) => item.value === cddListData?.cdd)?.label
          : "-",
        cdd_customer_type: cddListData?.cdd_customer_type
          ? cddCustomerTypeOptions?.find(
              (item) => item.value === cddListData?.cdd_customer_type,
            )?.label
          : "-",

        cdd_type: cddListData?.cdd
          ? cddOptions?.find((item) => item.value === cddListData?.cdd)?.label
          : "-",
        risk: cddListData?.risk && (
          <div className="flex items-center gap-2">
            {cddListData?.risk
              ? riskProfile?.find((item) => item.value == cddListData?.risk)
                  ?.label
              : ""}{" "}
            <CustomTooltip message={"Edit"}>
              <span>
                <FontAwesomeIcon
                  icon={faEdit}
                  size="1x"
                  onClick={() => {
                    toggleRisk(cddListData?.id, cddListData);
                  }}
                />
              </span>
            </CustomTooltip>
          </div>
        ),
        source: cddListData?.source ? (
          cddListData?.source?.includes("(SMS)") ? (
            <div className="flex items-center gap-2">
              {cddListData?.source}{" "}
              {cddListData?.verifications[0]?.sms_sent_date && (
                <AnimatedTooltip
                  title={
                    <div className="flex items-center gap-4 text-sm">
                      <span>SMS Sent Date:</span>
                      <span className="flex items-center gap-1.5">
                        <Calendar className="h-4 w-4" />
                        {moment(
                          cddListData?.verifications[0]?.sms_sent_date,
                          "DD-MM-YYYY HH:mm:ss",
                        ).format("DD MMM YYYY")}
                      </span>

                      <span className="flex items-center gap-1.5">
                        <Clock3 className="h-4 w-4" />
                        {moment(
                          cddListData?.verifications[0]?.sms_sent_date,
                          "DD-MM-YYYY HH:mm:ss",
                        ).format("hh:mm:ss A")}
                      </span>
                    </div>
                  }
                >
                  <CalendarClockIcon className="h-4 w-4 text-webPrimary" />
                </AnimatedTooltip>
              )}
            </div>
          ) : (
            cddListData?.source
          )
        ) : (
          ""
        ),

        verification_document_type: "",
        date_verified: cddListData?.verifications[0]?.date_verified
          ? cddListData?.verifications[0]?.date_verified
          : "",
        verified_by: cddListData?.verifications[0]?.verified_by
          ? formatName(
              cddListData?.verifications[0]?.verified_by?.first_name,
              cddListData?.verifications[0]?.verified_by?.last_name,
            )
          : "",
        method: "",
        bureau: (
          <CDDStatus
            cdd={cddListData?.cdd == 0 ? "simplified" : "enhanced"}
            contactType={
              cddListData?.joint_account_id
                ? "joint account"
                : cddListData?.beneficiary_id
                  ? "beneficiary"
                  : cddListData?.vendor_id
                    ? getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "vendors",
                        "vendor",
                      )
                    : cddListData?.contact_id
                      ? getModuleNamingBySlug(
                          organizationData?.organizationData,
                          "contacts",
                          "customer",
                        )
                      : ""
            }
            data={cddListData}
            id={cddListData?.id}
            type={"bureau"}
            fetchData={fetchCDDs}
          />
        ),
        dvs: (
          <CDDStatus
            cdd={cddListData?.cdd == 0 ? "simplified" : "enhanced"}
            contactType={
              cddListData?.joint_account_id
                ? "joint account"
                : cddListData?.beneficiary_id
                  ? "beneficiary"
                  : cddListData?.vendor_id
                    ? getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "vendors",
                        "vendor",
                      )
                    : cddListData?.contact_id
                      ? getModuleNamingBySlug(
                          organizationData?.organizationData,
                          "contacts",
                          "customer",
                        )
                      : ""
            }
            data={cddListData}
            id={cddListData?.id}
            type={"dvs"}
            fetchData={fetchCDDs}
          />
        ),
        pep: (
          <CDDStatus
            cdd={cddListData?.cdd == 0 ? "simplified" : "enhanced"}
            contactType={
              cddListData?.joint_account_id
                ? "joint account"
                : cddListData?.beneficiary_id
                  ? "beneficiary"
                  : cddListData?.vendor_id
                    ? getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "vendors",
                        "vendor",
                      )
                    : cddListData?.contact_id
                      ? getModuleNamingBySlug(
                          organizationData?.organizationData,
                          "contacts",
                          "customer",
                        )
                      : ""
            }
            data={cddListData}
            id={cddListData?.id}
            type={"pep"}
            fetchData={fetchCDDs}
          />
        ),
        sanction: (
          <CDDStatus
            cdd={cddListData?.cdd == 0 ? "simplified" : "enhanced"}
            contactType={
              cddListData?.joint_account_id
                ? "joint account"
                : cddListData?.beneficiary_id
                  ? "beneficiary"
                  : cddListData?.vendor_id
                    ? getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "vendors",
                        "vendor",
                      )
                    : cddListData?.contact_id
                      ? getModuleNamingBySlug(
                          organizationData?.organizationData,
                          "contacts",
                          "customer",
                        )
                      : ""
            }
            data={cddListData}
            id={cddListData?.id}
            type={"sanction"}
            fetchData={fetchCDDs}
          />
        ),
        adverse_media: (
          <AdverseMedia
            adverse_media_result={
              cddListData?.summaries[0]?.adverse_media_result
            }
            reference_no={cddListData?.summaries[0]?.request_id}
          />
        ),
        action: (
          <>
            <span className="flex items-center gap-2 justify-center">
              {cddListData?.kyb_report_file ? (
                <KYBReportDownload
                  setLoading={setLoading}
                  kyb_report_file={cddListData?.kyb_report_file}
                />
              ) : (
                <></>
              )}
              {cddListData?.status === 1 ? (
                <Button
                  size={"sm"}
                  className={
                    contactData?.type == 2
                      ? "bg-green-800 hover:bg-green-900 text-white h-6 px-2"
                      : "bg-green-500 hover:bg-green-600 text-white h-6 px-2"
                  }
                >
                  <div className="flex items-center gap-1">
                    {contactData?.type == 2 ? (
                      <Landmark size={14} />
                    ) : (
                      <CheckCircle2 size={14} />
                    )}
                    <span>Verified</span>
                  </div>
                </Button>
              ) : cddListData?.status === 2 || cddListData?.status === 3 ? (
                <Button
                  size={"sm"}
                  className={
                    cddListData?.status === 2
                      ? "bg-yellow-500 hover:bg-yellow-600 text-white h-6 px-2"
                      : "bg-red-500 hover:bg-red-600 text-white h-6 px-2"
                  }
                >
                  <div className="flex items-center gap-1">
                    <Clock size={14} />
                    <span>
                      {cddListData?.status === 2 ? "Pending" : "Expired"}
                    </span>
                  </div>
                </Button>
              ) : (
                <>
                  {cddListData?.cdd === "1" && !user && (
                    <>
                      <CustomTooltip message={"Escalate"}>
                        <span>
                          <LucideMessageSquareShare
                            size={18}
                            onClick={() => {
                              toggleConfirmEscalated(
                                cddListData?.id,
                                cddListData,
                              );
                            }}
                          />
                        </span>
                      </CustomTooltip>
                      <span>/</span>
                    </>
                  )}

                  {cddListData?.source && cddListData?.risk ? (
                    <CDDVerifyModal
                      loading={loading}
                      listData={cddListData}
                      setCddItem={setCddItem}
                      setCddId={setCddId}
                      cddItem={cddItem}
                      customerType={contactData?.type}
                      setLoading={setLoading}
                      cddId={cddId}
                      sectionType={cddListData?.cdd_customer_type}
                      fecthData={fetchCDDs}
                      defaultMobile={
                        contactData?.mobile
                          ? contactData?.mobile[0] === "+"
                            ? contactData?.mobile
                            : `+${contactData?.mobile}`
                          : ""
                      }
                      defaultABN={contactData?.abn}
                      cdd={cddListData?.cdd}
                    />
                  ) : (
                    // `${cddListData?.source == "KYB" ? "KYB" : "KYC"} Incomplete`
                    <KYCIncomplete
                      contactType={
                        cddsList[0]?.joint_account_id
                          ? 4
                          : cddsList[0]?.beneficiary_id
                            ? 3
                            : cddsList[0]?.contact_id
                              ? 2
                              : cddsList[0]?.vendor_id
                                ? 1
                                : ""
                      }
                      amlCTFEnable={amlCTFEnable}
                      contact={contactData}
                      type={contactData?.type}
                      entityType={contactData?.entity_type}
                      fetchData={() => fetchCDDs()}
                    />
                  )}
                </>
              )}
            </span>
          </>
        ),
      });
    }
    return items;
  };

  const CDDs = cddsGenerator(cddsList[0]?.verifications?.length);

  //* End: Vendor Table List Record Generation

  //* Start: Vendor List Columns

  const columns = user
    ? [
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "verification_document_type",
          text: "Document Type",
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "date_verified",
          text: "Date Verified",
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "verified_by",
          text: "Verified By",
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "method",
          text: "Method",
        },
        // {
        //   dataField: "source",
        //   text: "Source",
        //   headerClasses: THClasses,
        //   classes: TDClasses,
        // },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "biometrics",
          text: "Biometrics",
        },
        {
          dataField: "dvs",
          text: "DVS",
          headerClasses: THClasses,
          classes: TDClasses,
        },
        {
          dataField: "bureau",
          text: "Bureau",
          headerClasses: THClasses,
          classes: TDClasses,
        },

        {
          dataField: "pep",
          text: "PEP",
          headerClasses: THClasses,
          classes: TDClasses,
        },
        {
          dataField: "sanction",
          text: "Sanctions",
          headerClasses: THClasses,
          classes: TDClasses,
        },
        {
          dataField: "adverse_media",
          text: "Adverse Media",
          headerClasses: THClasses,
          classes: TDClasses,
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "action",
          text: "Action",
          align: "center",
          headerAlign: "center",
          style: { width: "127px" },
        },
      ]
    : [
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "cdd_type",
          text: "CDD Type",
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "verification_document_type",
          text: "Document Type",
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "date_verified",
          text: "Date Verified",
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "verified_by",
          text: "Verified By",
        },

        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "method",
          text: "Method",
        },
        {
          dataField: "risk",
          text: "Risk Profile",
          headerClasses: THClasses,
          classes: TDClasses,
        },
        // {
        //   dataField: "source",
        //   text: "Source",
        //   headerClasses: THClasses,
        //   classes: TDClasses,
        // },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "biometrics",
          text: "Biometrics",
        },
        {
          dataField: "dvs",
          text: "DVS",
          headerClasses: THClasses,
          classes: TDClasses,
        },
        {
          dataField: "bureau",
          text: "Bureau",
          headerClasses: THClasses,
          classes: TDClasses,
        },

        {
          dataField: "pep",
          text: "PEP",
          headerClasses: THClasses,
          classes: TDClasses,
        },
        {
          dataField: "sanction",
          text: "Sanctions",
          headerClasses: THClasses,
          classes: TDClasses,
        },
        {
          dataField: "adverse_media",
          text: "Adverse Media",
          headerClasses: THClasses,
          classes: TDClasses,
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "action",
          text: "Action",
          align: "center",
          headerAlign: "center",
          style: { width: "127px" },
        },
      ];

  //* End: Vendor List Columns

  //* End: Vendor List Sorting

  //* End: Vendor List and URL Mangement useEffect

  return (
    <MainBody
      search={false}
      actionContent={false}
      loading={loading}
      expandList={true}
      innerBody={true}
      parentHeight={true}
      // mainClassName="w-[calc(100%-3rem)]"
    >
      {/* Vendor Table and Pagination */}
      <div className="custom-table">
        <div className="table-body-class">
          <BootstrapTable
            keyField="id"
            remote
            data={CDDs}
            columns={columns}
            rowClasses={TRClasses}
            noDataIndication="No Data Found"
            classes={TableClasses}
            wrapperClasses={TableWrapClasses}
          />
        </div>

        <Confirmation
          title={"Verify Data"}
          open={confirmVerify}
          setOpen={setConfirmVerify}
          toggleShow={() => {
            toggleConfirmVerify();
          }}
          className="sm:max-w-1/2"
          message={
            <>
              <div>Are you sure you want to verify the record?</div>
              <div className="grid grid-cols-1 text-left mt-2">
                <div className="grid gap-2">
                  <Label htmlFor="phone">
                    <CustomLabelText
                      required={cddItem?.method === 2 ? true : false}
                      labelText="Mobile No."
                      errorField={""}
                    />
                  </Label>
                  <PhoneInput
                    onChange={(e) => {
                      setMobile(e);
                    }}
                    value={mobile}
                    defaultValue={"+61"}
                    defaultCountry={"AU"}
                    minLength={15}
                    maxLength={15}
                  />
                </div>
                <div className="flex items-start space-x-2 mt-4">
                  <Checkbox
                    id="terms"
                    checked={consent}
                    name="same_address"
                    onClick={() => {
                      setConsent(!consent);
                    }}
                  />
                  <label
                    htmlFor="terms"
                    className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-justify"
                  >
                    I confirm that I am authorised to conduct this identity
                    check and I consent to information being checked with the
                    document issuer or official record holder via third party
                    systems for the purpose of confirming customer identity.
                    Would you like Myna Australia Pty Ltd to verify the id now?
                  </label>
                </div>
              </div>
            </>
          }
          disabled={cddItem?.method === 2 ? !mobile && !consent : !consent}
          okAction={async () => {
            handleVerifyID();
            toggleConfirmVerify();
          }}
          cancelAction={() => {
            toggleConfirmVerify();
          }}
        />

        {showVisual && (
          <ResponsiveDrawerForm
            description={""}
            title={`Visual Changes`}
            handleOpen={() => {}}
            handleClose={() => {
              toggleVisual();
            }}
            write={true}
            buttonText={""}
            className={"sm:max-w-3xl"}
            open={showVisual}
            buttonClassName={""}
            popupType={"cdds"}
            setOpen={setShowVisual}
          >
            <VerifyModal
              data={cddItem}
              toggleVisual={toggleVisual}
              fetchData={fetchCDDs}
            />
          </ResponsiveDrawerForm>
        )}

        {showRisk && (
          <ResponsiveDrawerForm
            description={""}
            title={`Risk Change`}
            handleOpen={() => {}}
            handleClose={() => {
              toggleRisk();
            }}
            write={true}
            buttonText={""}
            className={"sm:max-w-3xl"}
            open={showRisk}
            buttonClassName={""}
            popupType={"cdds"}
            setOpen={setShowRisk}
          >
            <RiskChange
              data={cddItem}
              toggleRisk={toggleRisk}
              fetchData={fetchCDDs}
            />
          </ResponsiveDrawerForm>
        )}

        {confirmEscalated && (
          <ResponsiveDrawerForm
            description={""}
            title={`Escalated`}
            handleOpen={() => {}}
            handleClose={() => {
              toggleConfirmEscalated();
            }}
            write={true}
            buttonText={""}
            open={confirmEscalated}
            buttonClassName={""}
            popupType={"cdds"}
            setOpen={setConfirmEscalated}
            className={"sm:max-w-3xl"}
          >
            <EscalatedModal
              data={cddItem}
              toggleConfirmEscalated={toggleConfirmEscalated}
              fetchData={fetchCDDs}
            />
          </ResponsiveDrawerForm>
        )}
      </div>
    </MainBody>
  );
};

export default ExpandContactTypeCDD;
// * End: Vendor Listing Page
